import { defineCopy } from "@tami/core/intl";

import { DEMO_ORG_MODE_SWITCH_COPY_EN_US } from "./en-us/demo-org-mode-switch.copy";
import { DEMO_ORG_MODE_SWITCH_COPY_ES_ES } from "./es-es/demo-org-mode-switch.copy";

export const DEMO_ORG_MODE_SWITCH_COPY_PT_BR = {
  ariaLabel: "Escolha o tipo de conta na demonstração",
  creator: {
    label: "Sou Creator",
    shortLabel: "Creator",
    hint: "Você e as suas redes",
  },
  collab: {
    label: "Sou Collab",
    shortLabel: "Collab",
    hint: "Você e o seu quadro de creators",
  },
} as const;

export const DEMO_ORG_MODE_SWITCH_COPY = defineCopy(DEMO_ORG_MODE_SWITCH_COPY_PT_BR, {
  "en-US": DEMO_ORG_MODE_SWITCH_COPY_EN_US,
  "es-ES": DEMO_ORG_MODE_SWITCH_COPY_ES_ES,
});
